import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={cn("bg-[#fbfcfc] border-t border-[#e6e8eb] mt-auto", className)}>
      <div className="container mx-auto px-4 py-8">
        {/* Desktop: Columns, Mobile: Single column */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-[#111835] mb-4">Navigation</h3>
            <div className="space-y-2">
              <Link 
                to="/" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/coach-auth" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                Coach & Parent Admin
              </Link>
              <Link 
                to="/admin/auth" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                FutWork.io
              </Link>
            </div>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-[#111835] mb-4">Support</h3>
            <div className="space-y-2">
              <button 
                onClick={() => alert('Help/FAQ coming soon!')}
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors text-left"
              >
                Help / FAQ
              </button>
              <Link 
                to="/contact-us" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                Contact
              </Link>
            </div>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-[#111835] mb-4">Legal</h3>
            <div className="space-y-2">
              <Link 
                to="/terms-conditions" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                Terms and Conditions
              </Link>
              <Link 
                to="/privacy-policy" 
                className="block text-sm text-[#0248c1]/70 hover:text-[#0248c1] transition-colors"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-8 border-t border-[#e6e8eb]">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <div className="text-sm text-[#111835]/60">
              © {currentYear} FutWork. All rights reserved.
            </div>
            <div className="text-xs text-[#111835]/60">
              v1.0.0
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}